import { render } from "./RestaurantImageLoader.vue?vue&type=template&id=3e65d6d0"
import script from "./RestaurantImageLoader.vue?vue&type=script&lang=js"
export * from "./RestaurantImageLoader.vue?vue&type=script&lang=js"

import "./RestaurantImageLoader.vue?vue&type=style&index=0&id=3e65d6d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__